import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "вступление",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#%D0%B2%D1%81%D1%82%D1%83%D0%BF%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5",
        "aria-label": "вступление permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Вступление`}</h2>
    <p>{`Данный проект представляет из себя TDS ( Traffic Delivery System ) - предназначенную для аналитики и распределения входящего трафика.`}</p>
    <h2 {...{
      "id": "особенности",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#%D0%BE%D1%81%D0%BE%D0%B1%D0%B5%D0%BD%D0%BD%D0%BE%D1%81%D1%82%D0%B8",
        "aria-label": "особенности permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Особенности`}</h2>
    <ul>
      <li parentName="ul">{`🤑 Бесплатный`}</li>
      <li parentName="ul">{`🚀 Быстрый`}</li>
      <li parentName="ul">{`⚡️ Простой в настройке`}</li>
      <li parentName="ul">{`♻️ Большое количество типов редиректа`}</li>
      <li parentName="ul">{`↗️ Удобная аналитика`}</li>
      <li parentName="ul">{`🔥 и многое другое ... `}</li>
    </ul>
    <h2 {...{
      "id": "фильтрация-траффика",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#%D1%84%D0%B8%D0%BB%D1%8C%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D1%82%D1%80%D0%B0%D1%84%D1%84%D0%B8%D0%BA%D0%B0",
        "aria-label": "фильтрация траффика permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Фильтрация траффика:`}</h2>
    <ul>
      <li parentName="ul">{`📱 тип устройства`}</li>
      <li parentName="ul">{`🏳️‍ страна`}</li>
      <li parentName="ul">{`🖥️ браузер`}</li>
      <li parentName="ul">{`📍 город`}</li>
      <li parentName="ul">{`👅 язык браузера`}</li>
      <li parentName="ul">{`платформа`}</li>
      <li parentName="ul">{`ОС`}</li>
      <li parentName="ul">{`по наличию ключевых слов в юзерагенте/рефере`}</li>
      <li parentName="ul">{`по спискам ip, сигнатур`}</li>
      <li parentName="ul">{`по маске в ipv6`}</li>
      <li parentName="ul">{`по пустому юзерагенту/реферу`}</li>
    </ul>
    <h2 {...{
      "id": "типы-редиректов",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#%D1%82%D0%B8%D0%BF%D1%8B-%D1%80%D0%B5%D0%B4%D0%B8%D1%80%D0%B5%D0%BA%D1%82%D0%BE%D0%B2",
        "aria-label": "типы редиректов permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Типы редиректов:`}</h2>
    <ul>
      <li parentName="ul">{`HTTP redirect`}</li>
      <li parentName="ul">{`JS redirect`}</li>
      <li parentName="ul">{`JS selection`}</li>
      <li parentName="ul">{`Remote`}</li>
      <li parentName="ul">{`Iframe`}</li>
      <li parentName="ul">{`Iframe redirect`}</li>
      <li parentName="ul">{`Meta redirect`}</li>
      <li parentName="ul">{`Показ текста, js, json, html, 400, 403, 404, 500 ошибок`}</li>
    </ul>
    <h2 {...{
      "id": "техническая-информация",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#%D1%82%D0%B5%D1%85%D0%BD%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B0%D1%8F-%D0%B8%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D1%8F",
        "aria-label": "техническая информация permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Техническая информация`}</h2>
    <p>{`Проект написан на `}<strong parentName="p"><em parentName="strong">{`MERN`}</em></strong>{` стеке c использовнием следущих библиотек, технологий:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/facebook/create-react-app"
        }}>{`React`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nodejs.org/en/"
        }}>{`Node`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.mongodb.com/"
        }}>{`Mongo DB`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.docker.com/"
        }}>{`Docker`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://expressjs.com/"
        }}>{`Express`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://eslint.org/"
        }}>{`Eslint`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://material-ui.com/"
        }}>{`Material-UI`}</a></li>
    </ul>
    <h2 {...{
      "id": "лицензия",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#%D0%BB%D0%B8%D1%86%D0%B5%D0%BD%D0%B7%D0%B8%D1%8F",
        "aria-label": "лицензия permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Лицензия`}</h2>
    <p>{` MIT © `}<a parentName="p" {...{
        "href": "https://github.com/dengivseti"
      }}>{`dengivseti`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      